import React, { ChangeEvent } from 'react';
import { Form } from 'react-bootstrap';

interface InputMaskProps {
  mask: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  name: string;
  isInvalid?: boolean;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
}

const InputMask: React.FC<InputMaskProps> = ({ 
  mask, 
  value, 
  onChange, 
  name, 
  isInvalid, 
  placeholder,
  className,
  disabled,
  ...props 
}) => {
  const applyMask = (value: string, mask: string): string => {
    let maskedValue = '';
    let valueIndex = 0;
    const cleanValue = value.replace(/\D/g, '');

    for (let i = 0; i < mask.length && valueIndex < cleanValue.length; i++) {
      if (mask[i] === '9') {
        maskedValue += cleanValue[valueIndex];
        valueIndex++;
      } else {
        maskedValue += mask[i];
      }
    }

    return maskedValue;
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const maskedValue = applyMask(e.target.value, mask);
    const syntheticEvent = {
      ...e,
      target: {
        ...e.target,
        name: name,
        value: maskedValue
      }
    } as ChangeEvent<HTMLInputElement>;
    onChange(syntheticEvent);
  };

  return (
    <Form.Control
      type="text"
      name={name}
      value={value}
      onChange={handleChange}
      isInvalid={isInvalid}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      {...props}
    />
  );
};

export default InputMask;
